import { Grid } from "@mui/material";
import { type FunctionComponent, type PropsWithChildren } from "react";

import DisplayComponent from "./DisplayComponent";
import { Container, Label } from "./ReadOnlyDetail.sc";
import { DisplayWrapper } from "./ShowField";

interface ReadOnlyDetailFieldProps {
    label: string;
    value: string | number | null | boolean | Date;
    type?: "date" | "checkbox";
    checkboxLabel?: string;
}

const ReadOnlyDetailField: FunctionComponent<PropsWithChildren<ReadOnlyDetailFieldProps>> = ({ label, value, type, checkboxLabel }) => {
    return (
        <Container container>
            <Grid size={4}>
                <Label>{label}</Label>
            </Grid>
            <Grid size={8}>
                <DisplayWrapper $type={type}>
                    <DisplayComponent type={type} value={value} checkboxLabel={checkboxLabel} />
                </DisplayWrapper>
            </Grid>
        </Container>
    );
};

export default ReadOnlyDetailField;
